// extracted by mini-css-extract-plugin
module.exports = {"modalFooterButtons":"EditModal_modalFooterButtons__Iby44"};